<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="ded_head" id="ded"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><a href="#/text/9780062973368_Contents#rded"><b>Dedication</b></a></span></p>
<p class="ded_para"><i>To Tamar</i></p>
<p class="ded_para"><i>“. . . And they seemed unto him but a few days”</i><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062973368_Dedication.vue?3ce9a60b